module.exports = "/_next/static/images/mokubaza-appearance-007f0ccca4814b004b21af623207c80d.png";